import { useData } from '../../hooks';
export const Data = props => {
  const {
    value
  } = useData(props);
  const childContext = props.children(value);

  if (childContext === false) {
    return null;
  }

  return childContext;
};
//# sourceMappingURL=es/Other/Data/Data.js.map